import React from 'react';
import ColumnText from './ColumnText';
import HeaderColumnCell from './HeaderColumnCell';
import SortIcon from './SortIcon';

const SortableColumn = props => {
    const {
        labelText,
        titleText,
        isLoading,
        sortDir,
        isSorted,
        sortByField,
        sortableProps,
        ...restProps
    } = props;

    const { sortKey, defaultSortDir = 'asc' } = sortableProps;

    const handleSort = () => sortByField(sortKey, defaultSortDir);
    const onClick = !isLoading ? handleSort : undefined;

    return (
        <HeaderColumnCell
            role='button'
            onClick={onClick}
            data-is-loading={isLoading}
            {...restProps}
        >
            <ColumnText labelText={labelText} titleText={titleText} />
            <SortIcon sortDir={sortDir} isSorted={isSorted} />
        </HeaderColumnCell>
    );
};

export default SortableColumn;
